import imageperfil from "@assets/images/imageperfil.png";
import styles from '../../users/styles/users.module.scss';
import { ICompany } from "../../../api/companies/types";
import companiesStyles from '@features/companies/styles/companies.module.scss';
import UIcon from '@/assets/uicons/UIcon';
import { useI18n } from '../../i18n/useI18n';

export interface ICompaniesTableBody {
  company: ICompany;
  onEdit: (company: ICompany) => void;
}

export const CompaniesTableBody = ({
  company,
  onEdit,
}: ICompaniesTableBody) => {
  const { t } = useI18n();

  function truncarPrimerPalabra(texto: string) {
    const anchoPantalla = window.innerWidth;

    if (anchoPantalla < 700) {
      const palabras = texto.split(' ');
      const primeraPalabra = palabras[0] + '...';
      return primeraPalabra;
    } else {
      return texto;
    }
  }

  return (
    <div className={styles["bodytableusers"]}>
      <div className={styles["bodytableusers__user"]}>
        <div className={styles["bodytableusers__user-text"]}>
          <div className={styles["bodytableusers__user-wrapper-user"]}>
            <img 
              src={imageperfil} 
              alt={t("companies_module.company_logo_alt")} 
              className={styles["bodytableusers__img"]} 
            />
            <span className={styles["bodytableusers__name"]}>
              {truncarPrimerPalabra(company.nameCompany)}
            </span>
          </div>
          <button 
            className={companiesStyles["companiesTable__actionBtn"]} 
            onClick={() => onEdit(company)}
            aria-label={t("companies_module.edit_company_aria_label")}
          >
            <UIcon name="edit" size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};
